'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CountryOptions = require('../../constants/CountryOptions');

var _CountryOptions2 = _interopRequireDefault(_CountryOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VcardExporter = function () {
  function VcardExporter() {
    _classCallCheck(this, VcardExporter);
  }

  _createClass(VcardExporter, [{
    key: 'header',
    value: function header() {
      var result = this.line(['BEGIN'], ['VCARD']);
      result += this.line(['VERSION'], ['2.1']);

      return result;
    }
  }, {
    key: 'footer',
    value: function footer() {
      var result = this.line(['REV'], [this.date()]);
      result += this.line(['END'], ['VCARD']);

      return result;
    }
  }, {
    key: 'date',
    value: function date() {
      return new Date().toISOString().replace(/[-:]/g, '').substring(0, 15) + 'Z';
    }
  }, {
    key: 'collection',
    value: function collection(items) {
      return items.join(';');
    }
  }, {
    key: 'line',
    value: function line(field, value) {
      return this.collection(field) + ':' + this.collection(value) + '\r\n';
    }
  }, {
    key: 'export',
    value: function _export(model) {
      var countries = _CountryOptions2.default.filter(function (option) {
        return option.value === model.values.country;
      });
      var country = countries ? countries[0] : null;

      var result = this.header();

      result += this.line(['N'], [[model.values.lastname, model.values.suffix].join(' '), model.values.forenames, '', '', model.values.nickname]);
      result += this.line(['FN'], [model.getTitle()]);
      // result += this.line(['PHOTO', 'ENCODING=b', 'TYPE=JPEG'], [ model.getImage() ])
      result += this.line(['TEL', 'HOME', 'VOICE'], [model.values.phone]);
      result += this.line(['TEL', 'HOME', 'CELL'], [model.values.mobile]);
      result += this.line(['ADR', 'HOME'], ['', model.values.address, '', model.values.city, model.values.region, model.values.zipcode, country ? country.label : '']);
      result += this.line(['EMAIL'], [model.values.email]);

      result += this.footer();

      return result;
    }
  }]);

  return VcardExporter;
}();

exports.default = VcardExporter;


//////////////////
// WEBPACK FOOTER
// ./js/modules/person/exporters/VcardExporter.js
// module id = 51
// module chunks = 0